import React, { useState } from "react";
import axios from "axios";
import "./Contact.css"; // Ensure you create this file

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  // UI States for better UX
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/contact/`, formData);
      setStatus("success");
      setFormData({ name: "", email: "", message: "" }); // Clear form
      
      // Clear success message after 5 seconds
      setTimeout(() => setStatus(null), 5000);

    } catch (error) {
      console.error("Error sending message", error);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-section">
      <div className="container">
        
        {/* Section Header */}
        <div className="text-center mb-5">
          <h5 className="section-subtitle">Get in Touch</h5>
          <h1 className="section-title">Contact Us</h1>
        </div>

        <div className="contact-wrapper">
          <div className="row g-0">
            
            {/* Left Column: Contact Info (Dark Blue) */}
            <div className="col-lg-5 contact-info-col">
              <div className="info-content">
                <h3>Contact Information</h3>
                <p className="info-desc">
                  Have a query about a surgery or appointment? Fill up the form or contact us directly.
                </p>

                <div className="info-item">
                  <div className="icon-circle">📞</div>
                  <div className="info-text">
                    <span>Phone</span>
                    <p>+91 8341555765</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon-circle">✉️</div>
                  <div className="info-text">
                    <span>Email</span>
                    <p>contact@arthroscopydoc.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="icon-circle">📍</div>
                  <div className="info-text">
                    <span>Location</span>
                    <p>Medicover Out Patient Center, HITEC City, Hyderabad</p>
                  </div>
                </div>

                {/* Decorative Element */}
                <div className="circle-decor"></div>
              </div>
            </div>

            {/* Right Column: Form (White) */}
            <div className="col-lg-7 contact-form-col">
              <div className="form-content">
                <h3>Send us a Message</h3>
                
                {status === 'success' && (
                  <div className="alert alert-success">✅ Message sent successfully! We will contact you soon.</div>
                )}
                {status === 'error' && (
                  <div className="alert alert-danger">❌ Failed to send message. Please try again.</div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label>Your Name</label>
                        <input
                          type="text"
                          className="form-control-styled"
                          placeholder="John Doe"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    
                    <div className="col-md-6 mb-4">
                      <div className="form-group">
                        <label>Email Address</label>
                        <input
                          type="email"
                          className="form-control-styled"
                          placeholder="john@example.com"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group mb-4">
                    <label>Message</label>
                    <textarea
                      className="form-control-styled"
                      placeholder="Write your query here..."
                      rows={4}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-submit">
                    <button 
                      className="btn btn-submit-contact" 
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;